var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorkshopFacilitatorActive({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 13,
    viewBox: "0 0 18 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7109 5.0886L17.5014 1.79102V11.4926L12.7109 8.19731",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7109 5.0886L17.5014 1.79102V11.4926L12.7109 8.19731",
    stroke: "#333333",
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.57095 0.537109H10.6408C11.7846 0.537109 12.7118 1.4643 12.7118 2.60806V10.6779C12.7118 11.8217 11.7846 12.7489 10.6408 12.7489H2.57095C1.42719 12.7489 0.5 11.8217 0.5 10.6779V2.60806C0.5 1.4643 1.42719 0.537109 2.57095 0.537109ZM8.18297 6.643C8.18297 7.43734 7.53903 8.08129 6.74468 8.08129C5.95034 8.08129 5.3064 7.43734 5.3064 6.643C5.3064 5.84866 5.95034 5.20471 6.74468 5.20471C7.53903 5.20471 8.18297 5.84866 8.18297 6.643Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkshopFacilitatorActive);
export default __webpack_public_path__ + "static/media/WorkshopFacilitatorActive.c49dbbafb23e6b616aa46acd8299c80b.svg";
export { ForwardRef as ReactComponent };